import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  GradeFilterWrap,
  UnitRangeCaretIcon,
  UnitRangeDropdownPanel,
  UnitRangeMenuOption,
  UnitRangeOptionCheckIcon,
  UnitRangeOptionCheckWrap,
  UnitRangeOptionLabel,
  UnitRangePillButton,
} from './component.styles'

const UnitRangeDropdown = ({ options, unitRangeLabel, onUnitRangeChange }) => {
  const [open, setOpen] = useState(false)
  const [selectedLabel, setSelectedLabel] = useState(
    () => unitRangeLabel || options[0] || '',
  )
  const wrapRef = useRef(null)

  useEffect(() => {
    setSelectedLabel(unitRangeLabel || options[0] || '')
  }, [unitRangeLabel])

  useEffect(() => {
    if (!open) return undefined
    const close = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <GradeFilterWrap ref={wrapRef}>
      <UnitRangePillButton
        aria-expanded={open}
        aria-haspopup="listbox"
        data-testid="unit-range-dropdown-trigger"
        onClick={() => setOpen(o => !o)}
        type="button"
      >
        {selectedLabel}
        <UnitRangeCaretIcon $open={open} aria-hidden>
          <path d="M11 1L6 6L1 1" />
        </UnitRangeCaretIcon>
      </UnitRangePillButton>
      {open && (
        <UnitRangeDropdownPanel aria-label="Unit range" role="listbox">
          {options.map((option, index) => (
            <UnitRangeMenuOption
              aria-selected={selectedLabel === option}
              data-testid={`unit-range-option-${index}`}
              key={option}
              onClick={() => {
                setSelectedLabel(option)
                setOpen(false)
                if (onUnitRangeChange) {
                  onUnitRangeChange(option)
                }
              }}
              role="option"
              type="button"
            >
              <UnitRangeOptionLabel>{option}</UnitRangeOptionLabel>
              <UnitRangeOptionCheckWrap aria-hidden>
                {selectedLabel === option && <UnitRangeOptionCheckIcon />}
              </UnitRangeOptionCheckWrap>
            </UnitRangeMenuOption>
          ))}
        </UnitRangeDropdownPanel>
      )}
    </GradeFilterWrap>
  )
}

UnitRangeDropdown.propTypes = {
  onUnitRangeChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  unitRangeLabel: PropTypes.string,
}

export default UnitRangeDropdown
